import axios from 'axios';

const PinService = {
  validate({ code }) {
    return axios.post('pin', { code }).catch((error) => {
      throw new Error(`PinService.validate ${error}`);
    });
  },
};

export default PinService;
